module.exports = __webpack_public_path__ + "img/right-arrow.b3ef02d8.svg";